import { PureComponent } from 'react';
import { ConnectedProps, connect } from 'react-redux';

import {
  clearFlashMessages,
  pushFlashMessage,
} from 'modules/main/store/ducks/flashMessages';
import { RouteComponentProps, withRouter } from 'utils/withRouter';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/ban-types
type InitialProps = {};
type OwnProps = InitialProps & RouteComponentProps;
type Props = OwnProps & PropsFromRedux;

class SetFlashMessages extends PureComponent<Props> {
  componentDidUpdate(prevProps: Props) {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (prevProps.location.pathname !== this.props.location.pathname) {
      // clear flash messages on page navigation
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.clearFlashMessages();
    }

    if (
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      prevProps.location.pathname !== this.props.location.pathname || // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      prevProps.location.state !== this.props.location.state
    ) {
      // load new flash message from router state
      const flashMessage =
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain, react/destructuring-assignment
        this.props.location.state && this.props.location.state.flashMessage;

      if (flashMessage) {
        // TODO: Fix this the next time the file is edited.
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.pushFlashMessage(flashMessage, true);
      }
    }
  }

  render() {
    return null;
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = ({ flashMessages }: any) => ({
  flashMessages,
});

const connector = connect(mapStateToProps, {
  pushFlashMessage,
  clearFlashMessages,
});

type PropsFromRedux = ConnectedProps<typeof connector>;

// eslint-disable-next-line import/no-default-export
export default withRouter(connector(SetFlashMessages));
